<template>
  <v-row dense>
    <v-col cols="12">
      <v-card
        tile
        color="primary"
        class="elevation-0 mb-2"
      >
        <v-card-title
          class="font-weight-medium grey--text pt-1 pb-2"
        >
          Usuarios
        </v-card-title>
        <v-card-subtitle class="pb-2">
          Lista de usuario
        </v-card-subtitle>
      </v-card>
      <v-card
        tile
        color="grey lighten-3"
        class="elevation-0"
      >
        <v-container v-if="allowDisplayData" fluid>
          <v-row dense>
            <v-col cols="3" sm="2">
              <v-select
                v-model="form.status"
                :items="userStatus"
                label="Estado"
                item-text="name"
                item-value="id"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="3" sm="4">
              <v-text-field
              v-model="form.search"
              label="Buscar"
              hide-details
              dense
              outlined
              append-icon="mdi-magnify"
            >
              <template v-if="form.search" v-slot:append>
                <v-icon
                  @click.prevent="crearFilters"
                  link
                >
                  mdi-close
                </v-icon>
              </template>
            </v-text-field>
            </v-col>

            <v-spacer></v-spacer>
            <v-col cols="3" sm="2">
            <v-btn
              dense
              outlined
              large
              color="success"
              block
              @click="showModalNewUser()"
            >
              Nuevo usuario +
          </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>

      <v-card v-if="allowDisplayData" class="elevation-0 mt-3" tile>
        <v-data-table
          :headers="headers"
          :items="users"
          class="elevation-0"
          :options.sync="options"
          :server-items-length="totalUsers"
          :loading="loading"
          disable-sort
        >
          <template v-slot:item.username="{ item }">
           {{ item.username.toLowerCase() }}
          </template>
          <template v-slot:item.fullname="{ item }">
              {{ item.fullname }}
          </template>
          <template v-slot:item.email="{ item }">
            {{ item.email }}
          </template>

          <template v-slot:item.created="{ item }">
            {{ item.created }}
          </template>
          <template v-slot:item.last_login="{ item }">
              {{ item.last_login }}
          </template>
          <template v-slot:item.is_active="{ item }">
            <v-chip
              small
              label
              :color="getColor(item.is_active)"
              dark
              class="v-btn--block v-chip-status"
            >
                {{ getStatusText(item.is_active) }}
            </v-chip>
          </template>
          <template v-slot:item.action="{ item }">

            <v-btn
                class="ma-2"
                outlined
                small
                fab
                color="indigo"
                 @click="showModalUpdateUser(item.id)"
            >
                <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn v-if='item.is_active'
                class="ma-2"
                outlined
                small
                fab
                color="indigo"
                @click="showModalResetPassword(item.id)"
            >
                <v-icon>mdi-autorenew</v-icon>
            </v-btn>

          </template>

        </v-data-table>
      </v-card>
        <v-alert v-else
          color="red"
          type="error"
        >
          Su usuario no tiene permiso, favor comunicarse con del departamento correspondiente..
        </v-alert>

    </v-col>
    <user-create-component
      v-model="showCreateUser"
    ></user-create-component>

    <user-update-component
      v-model="showUpdateUser"
      :userId="userId"
    ></user-update-component>

    <user-fast-password-reset
      v-model="showResetPassword"
      :userId="userId"
    ></user-fast-password-reset>

  </v-row>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import types from '@/types';
import UserCreateComponent from '@/components/UserCreateComponent';
import UserUpdateComponent from '@/components/UserUpdateComponent';
import UserFastPasswordReset from '@/components/UserFastPasswordReset';
import _ from 'lodash';
// import { bus } from '@/main';

export default {
  components: {
    UserCreateComponent,
    UserUpdateComponent,
    UserFastPasswordReset,
  },

  data() {
    return {
      form: {
        search: '',
        status: 2,
      },
      options: {},
      headers: [
        { text: 'Usuario', value: 'username' },
        { text: 'Nombre Completo', value: 'fullname', width: '15%' },
        { text: 'Email', value: 'email', width: '10%' },
        { text: 'Fecha de creación', value: 'created' },
        { text: 'Ultimo login', value: 'last_login' },
        { text: 'Estado', value: 'is_active' },
        {
          text: 'Acciones', value: 'action', sortable: false, align: 'end',
        },
      ],
      loading: true,
      userId: 0,
      showCreateUser: false,
      showUpdateUser: false,
      showChangePassword: false,
      showResetPassword: false,
      autoUpdate: true,
      interval: null,
      allowDisplayData: true,
    };
  },

  computed: {
    ...mapState(
      `${types.USER}`, [
        'userStatus',
        'users',
        'totalUsers',
      ],
    ),
    limit() {
      return this.options.itemsPerPage === -1
        ? this.totalUsers : this.options.itemsPerPage;
    },
  },

  watch: {
    form: {
      handler() {
        const clearPage = true;
        this.debouncedGetUsers(this.getOptions(clearPage));
      },
      deep: true,
    },
    options: {
      handler() {
        const clearPage = false;
        this.getUsers(this.getOptions(clearPage));
      },
      deep: true,
    },
  },

  methods: {
    ...mapMutations({
      [types.SHOW_BUSY]: `${types.APP}/${types.SHOW_BUSY}`,
      [types.HIDE_BUSY]: `${types.APP}/${types.HIDE_BUSY}`,
    }),
    ...mapActions({
      [types.SETUP_BACKOFFICE]: `${types.INVITATION}/${types.SETUP_BACKOFFICE}`,
      [types.GET_USERS]: `${types.USER}/${types.GET_USERS}`,
    }),
    getOptions(clearPage) {
      const params = {
        search: this.form.search,
        status: this.form.status,
        page: this.options.page,
        limit: this.limit,
      };
      if (clearPage) {
        delete params.page;
      }
      return params;
    },
    showModalNewUser() {
      this.showCreateUser = true;
    },
    showModalUpdateUser(userId) {
      this.userId = userId;
      this.showUpdateUser = true;
    },
    showModalResetPassword(userId) {
      this.userId = userId;
      this.showResetPassword = true;
    },
    getColor(status) {
      const colors = {
        true: 'success',
        false: 'grey',
      };
      return colors[status];
    },
    getStatusText(status) {
      const texts = {
        true: 'Activo',
        false: 'Inactivo',
      };
      return texts[status];
    },
    getAction(status) {
      const actions = {
        Pending: 'Check-in',
        'In House': 'Check-out',
        'Check Out': 'Ver',
        Cancelled: 'Ver',
        'Overdue In House': 'Check-out',
      };
      return actions[status];
    },
    getUsers(params) {
      this.loading = true;
      this[types.GET_USERS](params)
        .then(() => {
        })
        .catch((error) => {
          if (error.response.status === 403) {
            this.allowDisplayData = false;
          }
        })
        .finally(() => {
          this[types.HIDE_BUSY]();
          this.loading = false;
        });
    },
    dispatchAction(status, userId) {
      switch (status) {
        case 1:
          this.userId = userId;
          this.showChangePassword = true;
          this.showUpdateUser = true;
          break;
        case 0:
          this.userId = userId;
          this.showUpdateUser = true;
          break;
        default:
          this.$router.push({ name: 'Todo' });
          break;
      }
    },
    crearFilters() {
      this.form.search = '';
    },
  },

  mounted() {
    this[types.SHOW_BUSY]('Cargando...');
    this.getUsers();
    this.debouncedGetUsers = _.debounce(this.getUsers, 1000);
    // bus.$on('refreshUserList', () => {
    //   this.getUsers();
    // });
  },

  destroyed() {
    clearInterval(this.interval);
  },
};
</script>

<style>
.v-data-table__wrapper tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, .05);
}
.v-chip-status {
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/views/user/UserList.vue